import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpinnerLoaderComponent } from './services/spinner-loader/spinner-loader.component';
import { RippleLoaderComponent } from './ripple-loader/ripple-loader.component';
import { TapToTopComponent } from './shared/components/tap-to-top/tap-to-top.component';
import { LayoutBoxComponent } from './shared/components/layout-box/layout-box.component';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [CommonModule, RouterModule, SpinnerLoaderComponent, RippleLoaderComponent, TapToTopComponent, LayoutBoxComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class AppComponent {
  [key: string]: any;
  isLoading = false;
}
